import { createActionTypes } from "@dpdgroupuk/redux-action-creator";
export const ACTION_NAMESPACE = "LOCAL_USER_DATA";
export const ACTIONS = createActionTypes(ACTION_NAMESPACE, {
  SET_ITEM: "SET_ITEM",
  CLEAR_ITEM: "CLEAR_ITEM",
  CLEAR_ALL: "CLEAR_ALL"
});